export function buildDocumentCollectionLink(requestId, query = {}) {
  const {
    uuid,
    taskId,
    campId,
    token,
    emedicId,
    partnerCategory,
    isEclinic,
  } = query;
  const params = new URLSearchParams();
  if (uuid) {
    params.set('uuid', String(uuid));
  }
  if (taskId) {
    params.set('task_id', String(taskId));
    params.set('task_uuid', String(uuid));
  }
  if (campId) {
    params.set('campId', String(campId));
  }
  if (token) {
    params.set('token', String(token));
  }
  if (emedicId) {
    params.set('emedicId', String(emedicId));
  }
  if (partnerCategory) {
    params.set('partnerCategory', String(partnerCategory));
  }
  if (isEclinic) {
    params.set('isEclinic', String(isEclinic));
  }
  return `/documents/${requestId}?${params.toString()}`;
}

export function documentCollectionPathFromLink(link) {
  if (!link) {
    return null;
  }
  try {
    const url = link.startsWith('http')
      ? new URL(link)
      : new URL(link, window.location.origin);
    return `${url.pathname}${url.search}`;
  } catch {
    return link.startsWith('/') ? link : null;
  }
}
